import React, {useEffect} from 'react';
import {useAppDispatch, useAppSelector} from "../../hooks/redux";
import {getIsAppInitialized} from "../../store/selectors/appSelector";
import LoadingFullScreen from "../../components/Utils/Loading/LoadingFullScreen/LoadingFullScreen";
import {checkAuth} from "../../store/actions/AuthActions";
import {appSlice} from "../../store/reducers/AppSlice";
import {toast} from "react-toastify";
import {EnumLanguage} from "../../enums/EnumLanguage";
import {getTextsThunk} from "../../store/actions/TextsActions";
import {getModulesThunk} from "../../store/actions/ModulesActions";


const InitializationApp = (Component: React.FC) => {
    const WrapperComponent = (props: any) => {
        const isInitialized = useAppSelector(getIsAppInitialized)


        const dispatch = useAppDispatch()

        const language = localStorage.getItem('language') as EnumLanguage

        if (language) {
            dispatch(appSlice.actions.chooseLanguage(language))
        }

        useEffect(() => {
            Promise.all([
                dispatch(checkAuth()),
                dispatch(getTextsThunk()),
                dispatch(getModulesThunk())
                ]).then((value) => {
                if (value.every(isLoaded => isLoaded)) {
                    dispatch(appSlice.actions.setIsInitialized(true))
                }
            }).catch((value) => {
                toast.error(value)
                dispatch(appSlice.actions.setIsInitialized(true))
            })

        }, [dispatch])


        if (!isInitialized) {
            return <LoadingFullScreen/>
        } else {
            return <Component {...props}/>
        }
    }

    return WrapperComponent
};

export default InitializationApp;